import React from 'react';
import i18next from 'i18next';

import PageHero from '~components/PageHero';
import Breadcrumb, { BreadcrumbItem } from '~components/Breadcrumb';

import styles from './styles.module.scss';

interface Props {
  title: string;
  breadcrumb?: BreadcrumbItem[];
  /** "N Acciones" under the title. */
  count?: number;
  /** The list is still loading. */
  busy?: boolean;
  children: React.ReactNode;
}

/** Map screens' left column: a navy header over a list of cards that scrolls apart from the map. */
const MapSidePanel = ({ title, breadcrumb, count, busy, children }: Props) => (
  <aside className={styles.panel}>
    <PageHero
      variant="solid"
      compact
      breadcrumb={breadcrumb && <Breadcrumb items={breadcrumb} />}
      title={title}
      subtitle={count !== undefined && (
        <>
          <span className={styles.count}>{count}</span>
          <span className={styles.countLabel}>{i18next.t('map:projects')}</span>
        </>
      )}
    />
    <div className={styles.list} aria-busy={busy}>{children}</div>
  </aside>
);

export default MapSidePanel;
